import React from "react";
export default () => (React.createElement("footer", { className: "page-footer" },
    React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "row justify-content-center" },
            React.createElement("div", { className: "col-12 footer_links" },
                React.createElement("a", { href: "/terms" }, "Terms of Service"),
                React.createElement("a", { href: "/privacy" }, "Privacy Policy"))))));
